module.exports = __webpack_public_path__ + "img/04-5.9b7104fd.png";